module.exports = __webpack_public_path__ + "img/jk_icon_gerengongchengjikeclick.9d6d288b.png";